import { useState } from "react";
import { Card, Col, ListGroup, Nav, ProgressBar, Row, Tab } from "react-bootstrap";
import { ReactComponent as DocumentIcon } from '../../../Assets/images/icons copy/document-icon.svg';
import { ReactComponent as UserGroupIcon } from '../../../Assets/images/payroll/user-group-icon.svg';
import { ReactComponent as MoneyIcon } from '../../../Assets/images/payroll/money-icon.svg';
import { MdOutlineInsertChart, MdOutlinePayment } from "react-icons/md";
import { RxDashboard } from "react-icons/rx";
import { FiFileText } from "react-icons/fi";
import { BsArrowUpSquare } from "react-icons/bs";
import { RiArrowRightUpLine } from "react-icons/ri";
import ManageSubcriptionPlans from "./TabNavigation/ManageSubcriptionPlans";
import BillingSubscription from "./TabNavigation/BillingSubscription";
import ActiveUsersSubscription from "./TabNavigation/ActiveUsersSubscription";
import PaymentMethodsSubscription from "./TabNavigation/PaymentMethodsSubscription";

const SubscriptionClientAdmin = () => {
    let [key, setKey] = useState("dashboard");

    return (
        <div className="subscription client-admin">
            <Tab.Container activeKey={key}>
                <Row className="g-0 setup-card">
                    <Col md={2} className="border-end border-light-subtle setupbox-height side-menu">
                        <Card className="h-100 rounded-0 border-0">
                            <Card.Body className="pt-0 px-0 overflow-y-auto">
                                <Nav variant="pills" className="flex-column w-100" onSelect={(k) => setKey(k)}>
                                    <Nav.Item>
                                        <Nav.Link eventKey='dashboard' className="hstack gap-2 rounded-2">
                                            <RxDashboard size={18} />
                                            <span className="fw-medium flex-fill">Dashboard</span>
                                        </Nav.Link>
                                        <Nav.Link eventKey='subscription' className="hstack gap-2 rounded-2">
                                            <MdOutlineInsertChart size={18} />
                                            <span className="fw-medium flex-fill">Subscription</span>
                                        </Nav.Link>
                                        <Nav.Link eventKey='billing' className="hstack gap-2 rounded-2">
                                            <DocumentIcon width={18} height={18} />
                                            <span className="fw-medium flex-fill">Billing</span>
                                        </Nav.Link>
                                        <Nav.Link eventKey='payment-methods' className="hstack gap-2 rounded-2">
                                            <MdOutlinePayment size={18} />
                                            <span className="fw-medium flex-fill">Payment Method</span>
                                        </Nav.Link>
                                        <Nav.Link eventKey='users' className="hstack gap-2 rounded-2">
                                            <UserGroupIcon width={18} height={18} />
                                            <span className="fw-medium flex-fill">Users</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={10} className="overflow-y-auto">
                        <Tab.Content>
                            {key === 'dashboard' && (
                                <Tab.Pane eventKey="dashboard">
                                    <div className="container-fluid py-3">
                                        <Card body className="mb-3">
                                            <Card.Subtitle className="mb-2">Dashboard</Card.Subtitle>
                                            <Row xs={1} sm={2} md={3} className="g-3 justify-content-center">
                                                <Col>
                                                    <Card className="border-0 h-100" style={{ '--bs-card-bg': '#ECFDF5' }}>
                                                        <Card.Body className='hstack px-3 py-2'>
                                                            <div className='icon rounded-2 p-2' style={{ backgroundColor: "#059967" }}>
                                                                <FiFileText size={32} className='text-white' />
                                                            </div>
                                                            <div className='vstack ps-2 align-self-center'>
                                                                <span className="text-secondary">Current Plan</span>
                                                                <span className="fs-6 fw-semibold">Premium</span>
                                                                <span className="text-success">$ 49.99/month</span>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                                <Col>
                                                    <Card className="border-0 h-100" style={{ '--bs-card-bg': '#FEFCEA' }}>
                                                        <Card.Body className='hstack px-3 py-2'>
                                                            <div className='icon rounded-2 p-2' style={{ backgroundColor: "#E0750A" }}>
                                                                <UserGroupIcon width={32} height={32} className='text-white' />
                                                            </div>
                                                            <div className='vstack ps-2 align-self-center'>
                                                                <span className="text-secondary">Users</span>
                                                                <span className="fs-6 fw-semibold">25/50</span>
                                                                <ProgressBar variant="orange rounded-2" now={25}
                                                                    className="bg-light-org border-0 rounded-2 mt-1" style={{ height: 8 }} />
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                                <Col>
                                                    <Card className="border-0 h-100" style={{ '--bs-card-bg': '#F7F3FF' }}>
                                                        <Card.Body className='hstack px-3 py-2'>
                                                            <div className='icon rounded-2 p-2' style={{ backgroundColor: "#A682F6" }}>
                                                                <MoneyIcon width={32} height={32} className='text-white' />
                                                            </div>
                                                            <div className='vstack ps-2 align-self-center'>
                                                                <span className="text-secondary">Next Billing</span>
                                                                <span className="fs-6 fw-semibold">June 15,2023</span>
                                                                <span className="text-success">$49.99</span>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Card>
                                        <Row xs={1} md={2} className="g-3 justify-content-center">
                                            <Col>
                                                <Card body className="h-100">
                                                    <Card.Subtitle>Recent Activity</Card.Subtitle>
                                                    <ListGroup variant="flush" className="mt-2">
                                                        <ListGroup.Item className="border-bottom">
                                                            <div className="hstack gap-2 w-100 justify-content-between">
                                                                <div className="hstack justify-content-center rounded-circle w-40px h-40px bg-success-subtle">
                                                                    <BsArrowUpSquare size={18} className="text-success" />
                                                                </div>
                                                                <div className="vstack flex-fill">
                                                                    <span className="fw-medium">Plan upgraded to Business</span>
                                                                    <small className="text-muted">May 15,2023</small>
                                                                </div>
                                                                <span className="text-muted">2 hours ago</span>
                                                            </div>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item className="border-bottom">
                                                            <div className="hstack gap-2 w-100 justify-content-between">
                                                                <div className="hstack justify-content-center rounded-circle w-40px h-40px bg-success-subtle">
                                                                    <BsArrowUpSquare size={18} className="text-success" />
                                                                </div>
                                                                <div className="vstack flex-fill">
                                                                    <span className="fw-medium">Payment Processed</span>
                                                                    <small className="text-muted">May 15,2023</small>
                                                                </div>
                                                                <span className="text-muted">2 hours ago</span>
                                                            </div>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item className="border-bottom">
                                                            <div className="hstack gap-2 w-100 justify-content-between">
                                                                <div className="hstack justify-content-center rounded-circle w-40px h-40px bg-success-subtle">
                                                                    <BsArrowUpSquare size={18} className="text-success" />
                                                                </div>
                                                                <div className="vstack flex-fill">
                                                                    <span className="fw-medium">Payment Failed</span>
                                                                    <small className="text-muted">May 15,2023</small>
                                                                </div>
                                                                <span className="text-muted">3 hours ago</span>
                                                            </div>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item className="border-bottom">
                                                            <div className="hstack gap-2 w-100 justify-content-between">
                                                                <div className="hstack justify-content-center rounded-circle w-40px h-40px bg-success-subtle">
                                                                    <BsArrowUpSquare size={18} className="text-success" />
                                                                </div>
                                                                <div className="vstack flex-fill">
                                                                    <span className="fw-medium">User Added</span>
                                                                    <small className="text-muted">May 15,2023</small>
                                                                </div>
                                                                <span className="text-muted">4 hours ago</span>
                                                            </div>
                                                        </ListGroup.Item>
                                                    </ListGroup>
                                                </Card>
                                            </Col>
                                            <Col>
                                                <Card body className="h-100">
                                                    <Card.Subtitle className="hstack justify-content-between">
                                                        <span className="fs-6">Plan Usage</span>
                                                        <span className="hstack link-secondary" role="button">
                                                            <span>Last 12 months</span>
                                                            <RiArrowRightUpLine size={16} className="ms-2" />
                                                        </span>
                                                    </Card.Subtitle>
                                                    <ListGroup variant="flush" className="mt-2">
                                                        <ListGroup.Item>
                                                            <div className="vstack">
                                                                <div className="hstack w-100 justify-content-between">
                                                                    <span>Users</span>
                                                                    <span className="fs-6 fw-medium">25/50</span>
                                                                </div>
                                                                <ProgressBar variant="success rounded-2" now={25}
                                                                    className="bg-success-subtle border-0 rounded-2 mt-1" style={{ height: 8 }} />
                                                            </div>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <div className="vstack">
                                                                <div className="hstack w-100 justify-content-between">
                                                                    <span>Stroage</span>
                                                                    <span className="fs-6 fw-medium">15GB/50GB</span>
                                                                </div>
                                                                <ProgressBar variant="warning rounded-2" now={30}
                                                                    className="bg-warning-subtle border-0 rounded-2 mt-1" style={{ height: 8 }} />
                                                            </div>
                                                        </ListGroup.Item>
                                                    </ListGroup>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </div>
                                </Tab.Pane>
                            )}
                            {key === 'subscription' && (
                                <Tab.Pane eventKey="subscription">
                                    <ManageSubcriptionPlans />
                                </Tab.Pane>
                            )}
                            {key === 'billing' && (
                                <Tab.Pane eventKey="billing">
                                    <BillingSubscription />
                                </Tab.Pane>
                            )}
                            {key === 'payment-methods' && (
                                <Tab.Pane eventKey="payment-methods">
                                    <PaymentMethodsSubscription />
                                </Tab.Pane>
                            )}
                            {key === 'users' && (
                                <Tab.Pane eventKey="users">
                                    <ActiveUsersSubscription />
                                </Tab.Pane>
                            )}
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </div>
    );
}

export default SubscriptionClientAdmin;